import React, { useEffect, useState, memo, useMemo } from "react";
import "./selectBox.scss";
import { useTranslation } from 'react-i18next';
import Select, { components } from "react-select";

const { ValueContainer, Placeholder } = components;

const CustomValueContainer = ({ children, ...props }) => {
  return (
    <ValueContainer {...props}>
      <Placeholder {...props} isFocused={props.isFocused}>
        {props.selectProps.placeholder}
      </Placeholder>
      {React.Children.map(children, (child) =>
        child && child.type !== Placeholder ? child : null
      )}
    </ValueContainer>
  );
};

const selectComponents = {
  ValueContainer: CustomValueContainer,
};

const SelectBox = (props) => {
  const { t } = useTranslation();
  const { option, placeholder_val, setstatusSelectedOptions, selected_val } =
    props;

  const status = useMemo(
    () => [
      { value: "s1", label: <label className="">{t("active")}</label> },
      { value: "s2", label: <label className="">{t("inactive")}</label> },
    ],
    [t]
  );

  const [selectBoxselected_val, setSelectBoxselected_val] = useState(
    selected_val && selected_val !== "value" ? selected_val : null
  );

  function statusSelect(data) {
    setstatusSelectedOptions(data);
  }

  useEffect(() => {
    if (!selected_val || selected_val === "value") {
      return;
    }
    // Only update when the selected value actually changes — not when the
    // parent re-renders with a new object identity for the same selection.
    setSelectBoxselected_val((prev) => {
      if (prev?.value === selected_val?.value) {
        return prev;
      }
      return selected_val;
    });
  }, [selected_val?.value]);

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
    }
  };

  return (
    <div className="common-select">
      <Select
        placeholder={placeholder_val ? placeholder_val : "Select"}
        options={option ? option : status}
        value={selectBoxselected_val}
        onChange={(opt) => statusSelect(opt.value)}
        classNamePrefix="common-select"
        components={selectComponents}
        getOptionLabel={(opt) => opt.label}
        isSearchable={true}
        onKeyDown={handleKeyPress}
      />
    </div>
  );
};

export default memo(SelectBox);
